"use client";

import { useState, useTransition } from "react";
import { toast } from "sonner";
import type { SerializedEditorState } from "lexical";
import dynamic from "next/dynamic";

import { Button } from "@/components/ui/button";
import { createNewsComment } from "@/query/news";

const Editor = dynamic(() => import("@/components/editor/editor").then((m) => m.Editor), { ssr: false });

export function NewsCommentForm({ newsId }: { newsId: number }) {
  const [content, setContent] = useState<SerializedEditorState | null>(null);
  const [isPending, startTransition] = useTransition();
  const [resetKey, setResetKey] = useState(0);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!content) {
      toast.error("Bitte einen Kommentar eingeben.");
      return;
    }
    startTransition(async () => {
      try {
        await createNewsComment(newsId, JSON.stringify(content));
        toast.success("Kommentar hinzugefügt!");
        setContent(null);
        setResetKey((k) => k + 1);
      } catch {
        toast.error("Fehler beim Hinzufügen des Kommentars.");
      }
    });
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <Editor key={resetKey} onSerializedChange={setContent} placeholder="Schreibe einen Kommentar…" />
      <div className="flex justify-end">
        <Button type="submit" disabled={isPending}>
          {isPending ? "Senden…" : "Kommentieren"}
        </Button>
      </div>
    </form>
  );
}
